/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useRef } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import '../App.css';
import { Paper, Box } from '@mui/material';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';
import Sidebar from '../components/Sidebar';
import { Navbar } from '../components';
import { variables } from '../components/Variables';
import LoadingOverlay from '../components/LoadingOverlay';
import CustomDataGrid from '../contexts/CustomDataGrid';

const columns = [
  { field: 'Sku', headerName: 'SKU', width: 300, headerAlign: 'left', align: 'left' },
  { field: 'PartNumber', headerName: 'Part Number', width: 250, headerAlign: 'left', align: 'left' },
  { field: 'Part_Desc', headerName: 'Part Description', width: 400, headerAlign: 'left', align: 'left' },
  { field: 'Each', headerName: 'Each', width: 200, type: 'number', headerAlign: 'left', align: 'left' },
  { field: 'MC_Count', headerName: 'Overpack Count', width: 200, type: 'number', headerAlign: 'left', align: 'left' },
  { field: 'Pallet_Count', headerName: 'Pallet Count', width: 150, type: 'number', headerAlign: 'left', align: 'left' },
];

const FgInventory = () => {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const { activeMenu, themeSettings } = useStateContext();
  const navigate = useNavigate();
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      if (localStorage.getItem('loginID')) {
        InboundTable();
      }
    }
  }, []);

  const InboundTable = () => {
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');
    const raw = JSON.stringify({
      UserId: JSON.parse(localStorage.getItem('loginID')) === null || undefined ? null : JSON.parse(localStorage.getItem('loginID')).UserId,
      ProcessName: 'SimpliSafePortal',
      PageName: 'FG Inventory',
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    fetch(`${variables.BASE_URL}FGInventory`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        if (JSON.parse(result)?.IsSuccess !== false && JSON.parse(result)?.IsAuthorize !== false) {
          setTableData(JSON.parse(result)?.FGInventory);
        } else if (JSON.parse(result)?.IsSuccess !== true && JSON.parse(result)?.IsAuthorize) {
          setTimeout(() => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'No Data available for this Date!',
            });
          }, 0);
          setTableData([]);
        } else if (JSON.parse(result)?.IsAuthorize !== true) {
          setTimeout(() => {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Access Denied!',
            });
            navigate('/');
          }, 0);
        }
        setLoading(false);
      });
  };
  return (
    <div className="flex relative dark:bg-main-dark-bg">
      {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
          <Sidebar />
        </div>
      ) : (
        <div className="w-0 dark:bg-secondary-dark-bg">
          <Sidebar />
        </div>
      )}
      <div style={{ width: `${activeMenu ? '100%' : '100%'} `, paddingLeft: `${activeMenu ? '300px' : '0px'}` }}>
        <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full ">
          <Navbar />
        </div>
        <div>
          {themeSettings}
          <div className="container-fluid">
            <div>
              <Paper className="table_backpaper">
                {loading ? (
                  <LoadingOverlay />
                ) : (
                  <Box className="table_positions">
                    <CustomDataGrid
                      name="Fg Inventory"
                      tableData={tableData}
                      column={columns}
                    />
                    <p className="dark:text-gray-500 text-gray-700 text-center " style={{ marginTop: '-30px' }}>
                      {variables.COPYRIGHT}
                    </p>
                  </Box>
                )}
              </Paper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FgInventory;
